/**
 * ルートパス定数（フロントエンド専用アプリ：トップ、Dashboard、Weekly Management のみ）
 */
export const RoutesName = {
  DASHBOARD: '/dashboard',
  DASHBOARDBYID: '/dashboard/:id',
  WEEKLY: '/weekly',
  WEEKLY_ID: '/weekly/:id',
  LEARNING_DATA: '/learning-data'
}
